var map = {
	"./featured-blogs.de-CH.json": 1312,
	"./featured-blogs.de-DE.json": 1313,
	"./featured-blogs.en-CA.json": 1314,
	"./featured-blogs.en-GB.json": 1315,
	"./featured-blogs.en-IN.json": 1316,
	"./featured-blogs.en-ME.json": 1317,
	"./featured-blogs.en-US.json": 1318,
	"./featured-blogs.es-EM.json": 1319,
	"./featured-blogs.es-ES.json": 1320,
	"./featured-blogs.fr-BE.json": 1321,
	"./featured-blogs.fr-CA.json": 1322,
	"./featured-blogs.fr-CH.json": 1323,
	"./featured-blogs.nl-BE.json": 1324,
	"./featured-blogs.nl-NL.json": 1325,
	"./featured-blogs.pl-PL.json": 1326,
	"./featured-blogs.pt-BR.json": 1327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1311;